import React from 'react'
import PropTypes from 'prop-types'
import useFocusManager from '../use-focus-manager'

const handler = (element) => element?.focus()

export default function useFocusLock({ enabled, containerRef }) {
  useFocusManager({ enabled, containerRef, handler })
}

export const HookConfigOptions = (props) => <div {...props} />

const DomElement = typeof Element === 'undefined' ? () => {} : Element

HookConfigOptions.propTypes = {
  /** If true, then focus-lock be enabled. */
  enabled: PropTypes.bool,

  /** Ref to the container that focus-lock will target. */
  containerRef: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element
    PropTypes.shape({ current: PropTypes.instanceOf(DomElement) }),
  ]),
}
